function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function MailUnread({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.844 18.176a1 1 0 01-1 1H4a1 1 0 01-1-1V9.99l6.457 4.673a4.072 4.072 0 002.55.902c.88 0 1.753-.287 2.475-.86l6.362-4.595v8.066zM21.65 9a3.22 3.22 0 01-1.864-.595l-6.51 4.706c-.757.598-1.814.597-2.607-.038L3.004 7.526A1 1 0 014 6.548h14.511a3.182 3.182 0 01-.11-.798c0-.425.086-.83.235-1.202H4c-1.655 0-3 1.346-3 3v10.628c0 1.654 1.345 3 3 3h15.844c1.654 0 3-1.346 3-3v-9.41A3.231 3.231 0 0121.65 9z",
    fill: props.color || "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.65 4c-.965 0-1.75.785-1.75 1.75s.785 1.75 1.75 1.75 1.75-.785 1.75-1.75S22.615 4 21.65 4",
    fill: "#ED1A3D"
  })));
}

const MemoMailUnread = React.memo(MailUnread);
export default MemoMailUnread;